import React from 'react'

import {
  Body1,
  Box,
  Color,
  Body2,
  Image,
  Display,
  FlexDirection,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import Buttons from 'Product/Buttons'
import { useDispatch, useSelector } from 'react-redux'

import { basketProductAdd, basketProductRemove } from 'actions/basket'
import { getProducts } from 'selectors/products'
import { getBasket, getProductCategories } from 'selectors/root'
import { getProductLimitReached } from 'utils/basketProductLimits'

import placeholderSrc from 'media/images/recipe-placeholder.png'

const IMAGE_WIDTH = 1000

export type SidesTileProps = {
  id: string
  images: Record<string, { src: string }>
  listPrice: string
  quantity: number
  stock: number
  title: string
}

const SidesImage = withCitrusTheme(Image, (theme) => ({
  borderRadius: theme.spacing(2),
  objectFit: 'cover',
  objectPosition: '% 50%',
}))

export const SidesTile = ({ id, images, listPrice, quantity, stock, title }: SidesTileProps) => {
  const dispatch = useDispatch()
  const basket = useSelector(getBasket)
  const products = useSelector(getProducts)
  const productsCategories = useSelector(getProductCategories)

  const outOfStock = stock <= 0
  const sideImage = images?.[IMAGE_WIDTH]?.src ?? placeholderSrc
  const limitReached = getProductLimitReached(id, basket, products, productsCategories)
  // This is an ugly hack for the chicken breast as it's the only one to be
  // 1 portion where the rest are all 2 (the usual hacky default for all sides)
  const portions = id === 'ce35b738-c98e-11ee-a818-064e823406e3' ? 1 : 2

  return (
    <Box display={Display.Flex}>
      <Box borderRadius={1}>
        <SidesImage alt={title} src={sideImage} width="120px" height="120px" />
      </Box>
      <Box flexGrow={1} paddingH={4}>
        <Body1 fontWeight={700} color={Color.ColdGrey_800}>
          {title}
        </Body1>
        <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
          <Body2>{`£${listPrice}`}</Body2>
          <Body2>{portions} portions</Body2>
        </Box>
      </Box>
      <Box>
        <Buttons
          isAvailable={!limitReached}
          limitReached={limitReached}
          onAdd={() => dispatch(basketProductAdd(id, 'sides_modal' as any))}
          onRemove={() => dispatch(basketProductRemove(id, 'sides_modal'))}
          outOfStock={outOfStock}
          productId={id}
          qty={quantity}
        />
      </Box>
    </Box>
  )
}
